import React,{Fragment} from 'react';
import ExistingTabletOrderItem from './ExistingTabletOrderItem';

const ExistingTabletOrderItemBlock = (props) => {

    const renderOrders = () => (
        props.list ? 
            props.list.map(card=>(
                <ExistingTabletOrderItem
                    key={card._id}
                    handelOnClickTabletNewOrder={props.handelOnClickTabletNewOrder}
                    {...card}
                />
            ))
        :null
    )

    return (
        <Fragment>
            {props.list ?
                props.list.length === 0 ?
                    <tr className="no_result text-center">
                       <td colSpan="4"> No orders have been placed. </td>
                    </tr>
                :null
            :null}
            { renderOrders(props.list)}

        </Fragment>
    );
};

export default ExistingTabletOrderItemBlock;